import { TeamGame } from './team-game';
import { Moment } from 'moment';
import { ScheduleViewModel } from './schedule-view-model';
export class GameRow {

    public messageMaxLength: number  = 15;
    public interval: number = 0;
    public games: TeamGame[] = [];
    public startTime: Date = new Date();
    public endTime: Date = new Date();
    public message: string = '';
    private _readonly: boolean = true;
    constructor(interval: number, startTime: Moment, duration: number, readonly: boolean) {
        const endTime = startTime.clone();
        endTime.add(duration, 'minutes');
        this.startTime = startTime.toDate();
        this.endTime = endTime.toDate();
        this.interval = interval;
        this._readonly = readonly;
    }

    public addGame(game: TeamGame): void {
        this.games.add(game);

        if (this.message.length < this.messageMaxLength) {
            this.message = this.games.select(g => `${g.homeTeam} - ${g.opponentTeam}`).join(', ').substr(0, this.messageMaxLength);
            if (this.message.length >= this.messageMaxLength) {
                this.message = this.message.substr(0, this.messageMaxLength) + '...';
            }
        }
    }
    public get isCustomRow(): boolean {
        return !this.games.any();
    }

    public get isEmpty(): boolean {
        return  (!this.isCustomRow) && this.games.all( g => g.homeTeam === ScheduleViewModel.freeSlotTeamName && g.opponentTeam === ScheduleViewModel.freeSlotTeamName);
    }

    public get gamesFiltered(): TeamGame[] {
        return this._readonly ? this.games.where(g => g.isValid) : this.games;
    }

}
